import React from 'react'
import { EncounterEntry } from '../../../../../types/FHIRTypes/Entry'
import { EncounterBundle } from '../../../../../types/FHIRTypes/Bundle'
import PaginationButtons from '../../../../PaginationButtons'
import FhirLoader from '../../../../FhirLoader'
import { EncounterTable } from '@teschglobal/tg-fhir-react-components'
import { Encounter } from '@teschglobal/tg-fhir-react-components/dist/types'

type EncounterListProps = {
    data: EncounterBundle | undefined;
    encounters: EncounterEntry[];
    isFetching: boolean;
    handleChangePage: (page: number) => void
    totalPages: number;
    currentPage: number;
}

const EncounterList: React.FC<EncounterListProps> = ({ encounters, isFetching, data, handleChangePage, totalPages, currentPage }) => {
    const patientEncounters = encounters && encounters.map((encounter) => encounter.resource) as Encounter[]
    return (
        <>
            {isFetching ? (
                <FhirLoader message='Loading...' />
            ) : (
                <>
                    {
                        data && data.total > 0 && (
                            <div className='my-3 fw-bold'>
                                <span role="status" aria-live="polite">{data?.total.toLocaleString()} record(s) found</span>
                                <PaginationButtons
                                    totalPages={totalPages}
                                    currentPage={currentPage}
                                    handleChangePage={handleChangePage}
                                />
                            </div>
                        )
                    }
                    <EncounterTable encounters={patientEncounters} />
                    {
                        data && data.total > 0 && (
                            <div className='my-3 fw-bold'>
                                <PaginationButtons
                                    totalPages={totalPages}
                                    currentPage={currentPage}
                                    handleChangePage={handleChangePage}
                                />
                            </div>
                        )
                    }
                </>
            )}
        </>
    )
}

export default EncounterList